import React from 'react';
import {blockLayout} from './Timeline';
import {blockColor} from './describe';

// What moves the show on from here, as the editor's headline and the operator's phone show it: a state glyph and,
// when the show is on a clock, the seconds to its next move.
export const fmtLeft = (s) => `${Math.floor(s / 60)}:${String(Math.max(0, Math.floor(s % 60))).padStart(2, '0')}`;
export const GLYPHS = {
    play: <path d="M7 4.5v15l12.5-7.5z" fill="currentColor"/>,
    pause: <><rect x="6" y="5" width="4.5" height="14" rx="1" fill="currentColor"/><rect x="13.5" y="5" width="4.5" height="14" rx="1" fill="currentColor"/></>,
    loop: <path d="M17 7H8.5A4.5 4.5 0 0 0 4 11.5M7 17h8.5a4.5 4.5 0 0 0 4.5-4.5M14 4l3 3-3 3M10 20l-3-3 3-3" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>,
    hold: <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor"/>,
};
const DIM = '#8a9099', GO = '#19f0a0';

// now: ms on the engine's clock (a phone adds its clock drift).
export const sceneStatus = (doc, live, playback, now = Date.now()) => {
    const block = live && doc.blocks[live.blockIndex];
    const L = block && blockLayout(doc, block);
    if (!L) return {glyph: 'hold', color: DIM, title: 'Waits for the operator'};
    if (!playback || playback.block !== block.id) return {glyph: 'pause', color: '#ffb347', title: 'Paused'};
    const t = (now - playback.startedAt) / 1000, i = live.sceneIndex;
    const nextAt = i + 1 < block.scenes.length && L.timed[i + 1] && !L.segmentOf(i + 1).open ? L.starts[i + 1] : null;
    if (L.segmentOf(i).open) return {glyph: 'loop', color: blockColor(block), title: 'Waits for the game · music looping'};
    if (nextAt != null && nextAt > t) return {glyph: 'play', color: GO, left: nextAt - t, title: 'Next scene in'};
    if (L.total > t) return {glyph: 'play', color: GO, left: L.total - t, title: block.musicEnd === 'next' ? 'Moves on in' : 'Music ends in'};
    return {glyph: 'play', color: GO, title: 'Playing'};
};

export const StatusGlyph = ({status, size = 26, fontSize = 24}) =>
    <span title={status.left != null ? `${status.title} ${fmtLeft(status.left)}` : status.title}
        style={{display: 'flex', alignItems: 'center', gap: 6, color: status.color, flex: 'none'}}>
        <svg width={size} height={size} viewBox="0 0 24 24">{GLYPHS[status.glyph]}</svg>
        {status.left != null && <span style={{fontSize, fontWeight: 800, fontVariantNumeric: 'tabular-nums', minWidth: fontSize * 2.6}}>{fmtLeft(status.left)}</span>}
    </span>;
